export default __webpack_public_path__ + "static/media/mob-menu.a54ad554.svg";